import Post from '../Post';

function SortableTopPosts({ topPostsQuery, sortOption, ...props }) {
    return (
        <Post
            posts={topPostsQuery.data}
            isLoading={topPostsQuery.isLoading || topPostsQuery.isIdle}
            isError={topPostsQuery.isError}
            sortOption={sortOption}
            {...props}
        />
    );
}

export default SortableTopPosts;
